import _ from "lodash";

export const constants = {
  // BASE_URL: "http://ec2-34-210-211-227.us-west-2.compute.amazonaws.com:7771"
  // BASE_URL: ''
  BASE_URL: "",
  // BASE_URL: 'http://localhost:7111'
};

export const DATE_FORMAT = "MM/DD/YYYY";

export const getPageTitle = (pathName, routes) => {
  _.flatMapDeep(routes);
  const pathNameString = pathName.split("/");
  let returnString = "";
  pathNameString.map((name, index) => {
    name = _.capitalize(decodeURIComponent(name));
    if (name) {
      index < pathNameString.length - 1
        ? (returnString += `${name} > `)
        : (returnString += name);
    }
  });
  return returnString;
};

export const pathNames = {
  DevOpsInsights: "DevOps Insights",
  cmdb: "CMDB",
  Businessinfoconfig: "Business Info Config",
  gnc: "Governance & Compliance",
  Vulnerability: "Vulnerability Management",
  compliance: "Compliance",
  Compliance: "Compliance",
  trmgCompliance: "TRMG Compliance",
  // "SBOMCompliance": "SBOM",
  circular09Compliance: "Circular 09 Compliance",
  IM8Compliance: "IM8 Compliance",
  securityHub: "Security Hub Findings",
  identityComplianceManagement: "Identity Compliance Management",
  CISBenchmarkCompliance: "CIS Benchmark Compliance",
  PII: "PII Data",
  PCIDSSCompliance: "PCI-DSS Compliance",
  CISOInsights: "CISO Insights",
  cisoInsights: "CISO Insights",
  AssetsCoverage: "Assets Coverage",
  assetsCoverage: "Assets Coverage",
  "on-premise": "On-Premise",
  cloud: "Cloud",
  SecurityHubFindings: "Security Hub Findings",
  // "CisoUserAccess": "User Access",
  Questions: "Questions",
  Topics: "Topics",
  Clause: "Clauses",
  SubTopics: "Sub-Topics",
  cloudAccessReview: "Cloud Access Governance",
  cloudAccessGovernance: "Access Governance",
  accessreview: "Access Review",
  SummaryPDF: "Summary PDF",
  ConfigurationFilter: "Configuration Filter",
  policyInsights: "Policy Insights",
  CloudCostInsights: "Cloud Cost Insights",
  licenseManagement: "License Management",
  AdminActivity: "Admin Activity",
  efficiency: "Efficiency",
  appConfig: "App Config",
  accessManagement: "Access Management",
  myRequest: "My Request",
  myApproval: "My Approval",
  auditLog: "Audit Log",
  configuration: "Configuration",
  settings: "Settings",
  tools: "Tools",
  groups: "Groups",
  PIIDataConfiguration: "PII Data Configuration",
  IAMPolicyCategorization: "IAM Policy Categorization",
  AWSStateCategorization: "AWS State Categorization",
  AWSConfiguration: "AWS Configuration",
  EmailScheduleConfiguration: "Email Schedule Configuration",
  DataImportScheduler: "Data Import",
  administration: "Administration",
  ldapConfig: "LDAP Configuration",
  smtpConfig: "SMTP Configuration",
  licenseConfig: "License Configuration",
  userManagement: "User Management",
  loggingConfig: "Logging Configuration",
  BusinessInfoConfig: "Business Info",
  roleAllocation: "Role Allocation",
  CMDBOverview: "CMDB Overview",
  UserInfoConfig: "Users",
  cloudaccounttable: "",
  cloudaccount: "Cloud Accounts",
  CloudCost: "Cloud Cost",
  AssessmentQuestionnaire: "Assessment Questionnaire",
  licenseconfigpage: "OS License",
  observability: "DevOps Insights",
  flowMetrics: "Flow Metrics",
  QAMetrics: "QA Metrics",
  doraMetrics: "Dora Metrics",
  peopleMetrics: "People Metrics",
  productivityMetrics: "Productivity Metrics",
  devopsMetrics: "Devops Metrics",
  opsMetrics: "Ops Metrics",
  DevExQuadrant: "DevEx Quadrant",
  incidentManagement: "Incident Management",
  changeManagement: "Change Management",
  userReview: "Application User Access Review",
  home: "Home",
  DeviceConfig: "Devices",
  users: "Users",
  accountids: "Cloud Accounts",
  Devices: "Devices",
  applicationConfiguration: "Application Configuration",
  project: "Projects",
  Summary: "Summary",
  sonarqubeRole: "SonarQube Roles",
  confluencecloudRole: "Confluence Cloud Roles",
  jiraRole: "Jira Configuration",
  jiracloudRole: "Jira Cloud Roles",
  jfrogRole: "JFrog Roles",
  nexusRole: "Nexus Roles",
  jenkinsRole: "Jenkins Roles",
  bitbucketRole: "Bitbucket Roles",
  bambooRole: "Bamboo Roles",
  SeveritySLAConfigurationRole: "Severity SLA Configuration",
  onboardingtools: "Onboard Tools",
  Architecture: "Architecture",
  cloudInsights: "Cloud Insights",
  "3DOverview": "3D Overview",
  Assessment: "Assessment",
  SBOMCISO: "SBOM CISO",
  RMiTCompliance: "RMiT Compliance",
  regulatoryCompliance: "Regulatory Compliance",
  SDLCInsights: "SDLC Insights",
  Servers: "Servers",
  ArchitectureCompliance: "Architecture Compliance",
  architectureCompliance: "Architecture Compliance",
  Overview: "Overview",
  CostOverview: "Cost Overview",
  CostInsights: "Cost Insights",
  projects: "Projects",
  jiraconfiguration: "Jira Configuration",
  ciso: "CISO",
  summary: "Summary",
  ITcompliance: "IT Compliance",
  accessGovernance: "Access Governance",
  cloudCostInsights: "Cloud Cost Insights",
  logReview: "Log Review",
  logReviewerInsights: "Log Reviewer Insights",
  logReviewer: "Log Reviewer",
  logApproverInsights: "Log Approver Insights",
  CISOlogReviewerInsights: "CISO Log Reviewer Insights",
  Sirar: "SIRAR",
  sirarLandings: "SIRAR",
  BSPCompliance: "BSP Compliance",
  VulnerabilityManagement: "Vulnerability Management",
};

export const userRestrictedAccess = [
  "/efficiency/onboardingtools",
  "/onboardingtools",
  "/efficiency/myApproval",
  "/configuration/administration/tools",
  "/configuration/administration/groups",
  "/configuration/administration/PIIDataConfiguration",
  "/configuration/administration/ldapConfig",
  "/configuration/administration/smtpConfig",
  "/configuration/administration/licenseConfig",
  "/configuration/administration/userManagement",
  "/configuration/administration/loggingConfig",
];
